export const FATIGUE_FILTER_REMOVED = 'fatigue-filter-removed';
export const INSIGHTS_FILTER_REMOVED = 'insights-filter-removed';
export const EVENT_JOB_FILTER_REMOVED = 'job-filter-removed';
